<template>
    <div>
        <responsive-button
                :setDisabled="isDisabled"
                :setClick="downloadFile"
                setColor="success"
                setDefaultIcon="cloud_download"
                setSmallIcon="cloud_download"
                :setCircular="iconMode"
        >
            Download
        </responsive-button>
    </div>
</template>

<script>
    import FileHandler from '@/fileHandler/Handler';
    const responsiveButton =()=> import( '@/components/common/mobile/Button');

    export default {
        name: "FileDownload",
        props:['name', 'belongUserId', 'setIcon', 'setDisabled','folder'],
        components:{ responsiveButton },
        data(){
            return{
               fileName: this.name
            };
        },
        methods: {
            downloadFile() {
                if(this.fileName === '') {
                    return;
                }
                let folder = this.folder ? this.folder : 'Document';
                let metadata = {
                    fileName: this.fileName.split(' ').join('_'),
                    belong: this.belongUserId,
                };

                this.downloadFileFromS3(folder, metadata);
            },
            async downloadFileFromS3(folder, metadata){
                await FileHandler.readFile(folder, metadata);
            }
        },
        computed:{
            iconMode (){
                return this.setIcon || false;
            },
            isDisabled(){
                return this.setDisabled || false;
            }
        }
    };
</script>

<style scoped>
</style>
